function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDollarSign = function SvgDollarSign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "17 13 10 17",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22.383 20.9c-2.23-.59-2.947-1.2-2.947-2.15 0-1.09.992-1.85 2.652-1.85 1.749 0 2.397.85 2.456 2.1h2.171a4.028 4.028 0 0 0-.92-2.468 3.903 3.903 0 0 0-2.233-1.342V13h-2.947v2.16c-1.906.42-3.438 1.68-3.438 3.61 0 2.31 1.876 3.46 4.617 4.13 2.456.6 2.947 1.48 2.947 2.41 0 .69-.482 1.79-2.653 1.79-2.023 0-2.819-.92-2.927-2.1H17c.118 2.19 1.729 3.42 3.615 3.83V31h2.947v-2.15C25.477 28.48 27 27.35 27 25.3c0-2.84-2.387-3.81-4.617-4.4Z",
    style: {
      fill: "currentColor"
    }
  }));
};
export default SvgDollarSign;